var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1024 1024"}},_vm.$listeners),[_c('path',{attrs:{"d":"M48.128 361.472l108.544-108.544L512 608.256l355.328-355.328 108.544 108.544L512 825.344 48.128 361.472z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }